import React from 'react';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import Vision from './components/Vision/Vision';
import Offerings from './components/Offerings/Offerings';
import Skills from './components/Skills/Skills';
import Projects from './components/Projects/Projects';
import Contact from './components/Contact/Contact';
import Employee from './components/Employee/Employee';
import Footer from './components/Footer/Footer';
import CookieConsent from './components/CookieConsent/CookieConsent';
import './App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <Vision />
        <Skills />
        <Offerings />
        <Projects />
        <Contact />
        <Employee />
      </main>
      <Footer />
      <CookieConsent />
    </div>
  );
}

export default App;
